import { render, staticRenderFns } from "./FPTableTransactionHistory.vue?vue&type=template&id=4a040d56"
import script from "./FPTableTransactionHistory.vue?vue&type=script&lang=js"
export * from "./FPTableTransactionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports